export const BASE_URL = process.env.REACT_APP_BASE_URL || "";

export const getBaseUrl = () => {
  return process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000";
};

export const getOktaLoginUrl = () => {
  return `${process.env.REACT_APP_API_BASE_URL}/api/okta/login`;
};

export const getOktaLogoutUrl = () => {
  return `${process.env.REACT_APP_API_BASE_URL}/api/okta/logout`;
};
